// Bilingual dictionary (EN + ID) for MEMOIRE landing page
export const translations = {
  en: {
    nav: {
      home: "Home",
      event: "Event",
      why: "Why Us",
      reach: "Reach Us",
    },
    hero: {
      brandTag: "DARI SETIAP SUDUT.",
      title: "EVERY GUEST HAS A STORY.",
      sub: "Setiap sudut menyimpan cerita — every angle holds a story worth keeping.",
      cta: "View more",
      chip: "Now accepting events for 2026",
    },
    occasions: {
      overline: "FOR EVERY MOMENT.",
      title: "For Every Occasion.",
      sub: "From intimate dinners to grand ceremonies, MEMOIRE gathers memories from every guest, every angle, every emotion.",
      items: {
        wedding: "WEDDING",
        birthday: "BIRTHDAY",
        trip: "TRIP",
        corporate: "CORPORATE EVENT",
        graduation: "GRADUATION",
      },
    },
    create: {
      number: "02.",
      title: "Create Your Event",
      body: "Set up your event page in minutes. Add the couple, the date, the story — and MEMOIRE generates a single QR code your guests can scan to contribute their photos and videos.",
      cta: "Read More",
    },
    collect: {
      number: "03.",
      title: "Collect Every Moment",
      body: "Your guests see the day differently. Every candid laugh, every hidden glance, every off-stage moment lands in one shared collection — no chasing, no group chats, no lost files.",
      cta: "Read More",
    },
    why: {
      overline: "WHY MEMOIRE?",
      title: "More than a shared gallery.",
      sub: "MEMOIRE helps you preserve the moments that professional cameras often miss.",
      features: [
        { n: "01.", t: "Every Guest Contributes", d: "Turn attendees into storytellers. One tap, one upload — everyone becomes part of the memory." },
        { n: "02.", t: "One QR For Everyone", d: "A single QR code replaces group chats, cloud folders, and 'send me the pics' texts." },
        { n: "03.", t: "All Memories In One Place", d: "Photos, videos, boomerangs — organised, private, and beautifully presented." },
        { n: "04.", t: "Relive Every Perspective", d: "See your day through hundreds of eyes. The full story, not just the highlights." },
      ],
    },
    noCamera: {
      title: "No Camera Can Capture Everything.",
      body: "Professional photographers capture the highlights. Guests capture the emotions in between. Together, they tell the complete story.",
      cta: "Read More",
    },
    cta: {
      title: "Ready to Preserve Every Perspective?",
      body: "Create your event today and start collecting memories from every guest.",
      placeholder: "mail@address.com",
      button: "Get Started",
      success: "Thank you — we'll be in touch soon.",
      error: "Please enter a valid email address.",
    },
    footer: {
      title: "Every Perspective Matters.",
      sub: "Because no camera can capture everything.",
      tag: "DARI SETIAP SUDUT.",
      copyright: "© 2026 MEMOIRE. All rights reserved.",
    },
  },
  id: {
    nav: {
      home: "Beranda",
      event: "Acara",
      why: "Kenapa Kami",
      reach: "Hubungi",
    },
    hero: {
      brandTag: "DARI SETIAP SUDUT.",
      title: "SETIAP TAMU PUNYA CERITA.",
      sub: "Setiap sudut menyimpan cerita — kumpulkan setiap momen dari setiap sudut pandang.",
      cta: "Lihat selengkapnya",
      chip: "Terima acara untuk 2026",
    },
    occasions: {
      overline: "UNTUK SETIAP MOMEN.",
      title: "Untuk Setiap Acara.",
      sub: "Dari makan malam intim hingga upacara megah, MEMOIRE mengumpulkan kenangan dari setiap tamu, setiap sudut, setiap emosi.",
      items: {
        wedding: "PERNIKAHAN",
        birthday: "ULANG TAHUN",
        trip: "PERJALANAN",
        corporate: "ACARA KORPORAT",
        graduation: "WISUDA",
      },
    },
    create: {
      number: "02.",
      title: "Buat Acara Anda",
      body: "Siapkan halaman acara dalam hitungan menit. Tambahkan pasangan, tanggal, dan cerita — MEMOIRE akan menghasilkan satu kode QR yang bisa dipindai tamu untuk mengunggah foto dan video mereka.",
      cta: "Selengkapnya",
    },
    collect: {
      number: "03.",
      title: "Kumpulkan Setiap Momen",
      body: "Para tamu melihat hari itu secara berbeda. Setiap tawa spontan, tatapan tersembunyi, dan momen di belakang layar — semuanya tersimpan dalam satu koleksi bersama.",
      cta: "Selengkapnya",
    },
    why: {
      overline: "KENAPA MEMOIRE?",
      title: "Lebih dari sekadar galeri bersama.",
      sub: "MEMOIRE membantu menyimpan momen-momen yang sering luput dari kamera profesional.",
      features: [
        { n: "01.", t: "Semua Tamu Berkontribusi", d: "Ubah tamu menjadi pencerita. Satu ketuk, satu unggahan — semua menjadi bagian dari kenangan." },
        { n: "02.", t: "Satu QR untuk Semua", d: "Satu kode QR menggantikan grup chat, folder cloud, dan pesan 'kirim fotonya dong'." },
        { n: "03.", t: "Semua Kenangan di Satu Tempat", d: "Foto, video, boomerang — tertata rapi, privat, dan tersaji indah." },
        { n: "04.", t: "Lihat dari Segala Sudut", d: "Lihat hari besar Anda dari ratusan mata. Cerita utuh, bukan sekadar sorotan." },
      ],
    },
    noCamera: {
      title: "Tidak Ada Kamera yang Bisa Merekam Segalanya.",
      body: "Fotografer profesional merekam sorotan. Tamu merekam emosi di antaranya. Bersama, mereka menceritakan kisah lengkapnya.",
      cta: "Selengkapnya",
    },
    cta: {
      title: "Siap Menjaga Setiap Sudut Pandang?",
      body: "Buat acara Anda hari ini dan mulai kumpulkan kenangan dari setiap tamu.",
      placeholder: "email@alamat.com",
      button: "Mulai Sekarang",
      success: "Terima kasih — kami akan segera menghubungi Anda.",
      error: "Mohon masukkan alamat email yang valid.",
    },
    footer: {
      title: "Setiap Sudut Berharga.",
      sub: "Karena tidak ada kamera yang bisa merekam segalanya.",
      tag: "DARI SETIAP SUDUT.",
      copyright: "© 2026 MEMOIRE. Semua hak dilindungi.",
    },
  },
};
